import { spinnerSlice } from "./spinnerSlice";

const { actions } = spinnerSlice;

export const spinnerCreate = (show, size) => dispatch => {
    return dispatch(actions.spinnerCreate({ show, size }));
}